import * as yup from "yup";

export const schema = yup.object().shape({
  nameCategories: yup
    .string()
    .min(2, "Minimum 2 symbols")
    .max(30, "Maximum 30 symbols")
    .matches(/^[a-zA-Z][^0-9]{0,28}$/, "Category name can not contain numbers"),
});
